import { render } from "./Outsourcing.vue?vue&type=template&id=685e41e4"
import script from "./Outsourcing.vue?vue&type=script&lang=js"
export * from "./Outsourcing.vue?vue&type=script&lang=js"

import "./Outsourcing.vue?vue&type=style&index=0&id=685e41e4&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__